import { useTranslation } from 'react-i18next';

import { Form } from '@arco-design/web-react';

import { CapacitySlider, CapacitySliderRow } from '@/components/CapacitySlider';

import { isVendorQuantityOptional } from '../../utils/postPaidPricing';
import { DEFAULT_QUANTITY_UNITS } from '../quantityUnit';

const FormItem = Form.Item;

export interface SystemDiskSizeFormFieldsProps {
  sizeField: string;
  minSize: number;
  maxSize: number;
  markCount: number;
  /** 容量单位，直建默认 Gi；计价跟随选型 quantityUnit */
  quantityUnit?: string;
  translateUnit?: boolean;
  billModelId?: string;
  paymentTiming?: string;
  skuType?: string;
  resourceEditMode?: string;
  requiredMessage?: string;
}

/** 系统盘容量滑条原子字段（卡片弹窗内复用） */
export function SystemDiskSizeFormFields({
  sizeField,
  minSize,
  maxSize,
  markCount,
  quantityUnit = DEFAULT_QUANTITY_UNITS.disk,
  translateUnit = false,
  billModelId,
  paymentTiming,
  skuType,
  resourceEditMode,
  requiredMessage,
}: SystemDiskSizeFormFieldsProps) {
  const { t } = useTranslation();
  const skipSizeRequired = isVendorQuantityOptional({ billModelId, paymentTiming, skuType, resourceEditMode });

  return (
    <CapacitySliderRow unit={quantityUnit}>
      <FormItem
        label={t('common:system.disk.size')}
        field={sizeField}
        required={!skipSizeRequired}
        rules={
          skipSizeRequired
            ? undefined
            : [
                {
                  required: true,
                  message: requiredMessage ?? t('data-center:please.enter.system.disk.size'),
                },
              ]
        }
        initialValue={minSize}
      >
        <CapacitySlider min={minSize} max={maxSize} markCount={markCount} translateUnit={translateUnit} unit={quantityUnit} />
      </FormItem>
    </CapacitySliderRow>
  );
}
